import { Navigate, Outlet, useLocation } from "react-router-dom";
import { clearAuthSession, isTokenExpired } from "../auth/auth";

const PrivateRoute = ({
  allowedRoles = null,
  blockedRoles = [],
  redirectTo = "/",
}) => {
  const location = useLocation();

  const token = sessionStorage.getItem("token");
  const role = sessionStorage.getItem("user_role");

  // ==========================================================
  // NOT LOGGED IN / TOKEN EXPIRED
  // ==========================================================
  if (!token || isTokenExpired(token)) {
    //redirect after successful login
    const redirectPath = location.pathname + location.search + location.hash;

    console.log("PRIVATE ROUTE HIT");
    console.log("Current location:", location.pathname);
    console.log(
      "Redirecting to:",
      `/login?redirect=${encodeURIComponent(redirectPath)}`,
    );

    clearAuthSession();

    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(redirectPath)}`}
        replace
      />
    );
    // return <Navigate to="/login" replace />;
  }

  // ==========================================================
  // ALLOWED ROLES
  // ==========================================================
  //FITTER can access the Manage Jobs section, but not Users, Inventory, Settings, Orders, etc.
  if (allowedRoles && !allowedRoles.includes(role)) {
    return (
      <Navigate to={role === "FITTER" ? "/managejobs" : redirectTo} replace />
    );
  }

  // ==========================================================
  // BLOCKED ROLES
  // ==========================================================
  if (blockedRoles.includes(role)) {
    const isFitterDistributor = role === "FITTER" || role === "DISTRIBUTOR";
    return (
      <Navigate to={isFitterDistributor ? "/managejobs" : redirectTo} replace />
    );
  }

  return <Outlet />;
};

export default PrivateRoute;
